module.exports = __webpack_public_path__ + "img/week.fc42a604.svg";